
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DispatchItem } from './dispatchitem';


@Injectable({ providedIn: 'root' })
export class DispatchItemService {
    constructor(private http: HttpClient) { }

    token = environment.token;
    dourl = environment.appURL + "/dispatchitems";

    //  GET ALL DISPATCH ITEMS
    getDispatchItems() { return this.http.get<DispatchItem[]>(this.dourl, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', []))); }


    //  POST DISPATCH ORDER / Create
    createDispatchItem(dio: DispatchItem) {
        var upd = JSON.stringify(dio);
        return this.http.post<DispatchItem>(`${environment.appURL}/dispatchitems/`, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
    }

    //  DELETE DISPATCHITEM
    deleteDisppatchItem(id: number) { return this.http.delete<DispatchItem>(`${this.dourl}/${id}`, { headers: new HttpHeaders({ "Authorization": "Bearer " + this.token }) }).pipe(tap(_ => { }), catchError(this.handleError('getDispatchOrders', []))); }

    //  REMOVE DISPATCHITEM REMOVE DO_
    removeDispatchItem(index: number): Observable<any> {
        let upd = "{\"dispatchorder\": null }";
        return this.http.put(this.dourl + "/" + index, upd, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) }).pipe(tap(_ => { }), catchError(this.handleError<any>('updateDispatchItem')));
    }

    //  UPDATE DISPATCH ITEM
    updateDispatchItem(item: DispatchItem): Observable<any> {return this.http.put(this.dourl + "/" + item.id, item, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) }).pipe(tap(_ => { }), catchError(this.handleError<any>('updateDispatchItem')));   }

    // ERROR HANDLING
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            console.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }



}
